import { getAllFreshSeedTransaction, getAllFreshSeedTransactionType, getFreshSeedTransactionDetail, deleteTransaction } from "@/api/fresh_seed_transaction";

const state = {
    freshSeedTransaction: null,
    freshSeedTransactionTypes: null,
    freshSeedTransactionDetail: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.freshSeedTransaction = data;
    },
    GET_ALL_TYPE: (state, data) => {
        state.freshSeedTransactionTypes = data;
    },
    GET_DETAIL: (state, data) => {
        state.freshSeedTransactionDetail = data;
    },
};

const actions = {
    async getAllFreshSeedTransaction({ commit }, notificationPagination) {
        let res = await getAllFreshSeedTransaction({ ...notificationPagination });
        if (res) {
            commit("GET_ALL", res); 
        }
    },

    async getAllFreshSeedTransactionType({ commit }) {
        let res = await getAllFreshSeedTransactionType();
        if (res) {
            commit("GET_ALL_TYPE", res); 
        }
    },

    async getFreshSeedTransactionDetail({ commit }, params) {
        let res = await getFreshSeedTransactionDetail(params);
        if (res) {
            commit("GET_DETAIL", res); 
        }
    },

    async deleteTransaction({ commit }, params) {
        let res = await deleteTransaction(params);
        if (res) {
            commit("GET_DETAIL", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/fresh_seed_transaction.js